import { memo } from "react";
import styled from "styled-components";
import color from "../../../helpers/color";
const Text = /*#__PURE__*/memo(styled.div.attrs(({
  style,
  ...props
}) => ({
  style: {
    ...props,
    ...style
  }
})).withConfig({
  displayName: "Text",
  componentId: "sc-mlwrc5-0"
})(["color:", ";"], color));
Text.displayName = "Text";
Text.defaultProps = {
  color: "text"
};
export default Text;
//# sourceMappingURL=index.js.map